import { useParams } from 'react-router-dom';
import { PlanUpgradePrompt } from '@/components/ui/plan-upgrade-prompt';

/**
 * A page that shows a prompt to upgrade to access a specific feature
 */
export function FeatureUpgradePage() {
  const { featureName } = useParams<{ featureName: string }>();
  
  // Format the feature name to be more readable
  const formattedFeatureName = featureName 
    ? featureName
        .replace(/-/g, ' ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    : 'This feature';

  return (
    <div className="container py-8">
      <PlanUpgradePrompt featureName={formattedFeatureName} />
    </div>
  );
}